export const MallErrorHandleFields = {
  name: {
    required: 'Please provide name',
  },
  coverPhoto: {
    required: 'Please provide cover photo',
  },
  description: {
    required: 'Please provide description',
  },
  address: {
    required: 'Please provide address',
  },
  latitude: {
    required: 'Please provide latitude',
  },
  longitude: {
    required: 'Please provide longitude',
  },
  emailAddress: {
    valid: 'please input the valid email',
  },
};
